import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  private _hasAcceptedCookies = false;
  private readonly cookieVisibility$ = new BehaviorSubject<boolean>(true);

  public get hasAcceptedCookies(): boolean {
    return this._hasAcceptedCookies;
  }

  public set hasAcceptedCookies(hasAcceptedCookies: boolean) {
    this._hasAcceptedCookies = hasAcceptedCookies;
    this.cookieVisibility$.next(!hasAcceptedCookies);
  }

  public acceptCookies(): void {
    this._hasAcceptedCookies = true;
    this.cookieVisibility$.next(false);
  }

  public dismissCookies(): void {
    this.cookieVisibility$.next(false);
  }

  public getCookiesBannerVisibility(): Observable<boolean> {
    return this.cookieVisibility$.asObservable();
  }
}
